export default () => import(/* webpackChunkName: 'coffee/app/blockchain/on-chain' */ './OnChain');
